import * as React from 'react';

import TextInput, {type TextInputProps} from '../TextInput';

import {useSearchableListContext} from './useSearchableList';
import {useSearchableListInput} from './useSearchableListInput';
import {useMergeRefs} from '@floating-ui/react';

export const SearchableListInput = React.forwardRef<
  HTMLInputElement,
  TextInputProps
>(({isDisabled: isDisabledProp, ...props}: TextInputProps, ref) => {
  const {refs} = useSearchableListContext();
  const mergedRefs = useMergeRefs([ref, refs.setReference]);

  const searchableListInputProps = useSearchableListInput({
    isDisabled: isDisabledProp,
    ref: mergedRefs,
    ...props,
  });

  return <TextInput {...searchableListInputProps} />;
});

SearchableListInput.displayName = 'SearchableListInput';

export default SearchableListInput;
